import { PaymentMethodConditions } from '@nemuru-eng/checkout-js';
import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { LoanApplicationCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/components/LoanApplicationCard';
import { LoanApplicationEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/LoanApplication/LoanApplicationEntity';
import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';
import { ProcessingStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/types/ProcessingStatus';
import { CardOnboardingApplicationCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/ProcessingStrategy/components/CardOnboardingApplicationCard';
import { CreditLineApplicationCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/ProcessingStrategy/components/CreditLineApplicationCard';

interface LoanApplicationCardFactoryProps {
  loanApplication: LoanApplicationEntity;
  processingStrategyEntity: AbstractProcessingStrategyEntity;
  paymentMethodConditions: PaymentMethodConditions[];
  processingStatus: ProcessingStatus | null;
}

export const LoanApplicationCardFactory = ({
  loanApplication,
  processingStrategyEntity,
  paymentMethodConditions,
  processingStatus,
}: LoanApplicationCardFactoryProps) => {
  const paymentMethodType = paymentMethodConditions[0]?.type;

  if (paymentMethodType === PaymentMethodType.CARD_ONBOARDING) {
    return (
      <CardOnboardingApplicationCard
        loanApplication={loanApplication}
        processingStrategyEntity={processingStrategyEntity}
        processingStatus={processingStatus}
      />
    );
  }

  if (paymentMethodType === PaymentMethodType.CREDIT_LINE) {
    return (
      <CreditLineApplicationCard
        loanApplication={loanApplication}
        processingStrategyEntity={processingStrategyEntity}
        processingStatus={processingStatus}
      />
    );
  }

  return (
    <LoanApplicationCard
      loanApplication={loanApplication}
      processingStrategyEntity={processingStrategyEntity}
      paymentMethodConditions={paymentMethodConditions}
      processingStatus={processingStatus}
    />
  );
};
